import { render, staticRenderFns } from "./Consignacoes.vue?vue&type=template&id=12da0ac6&"
import script from "./Consignacoes.vue?vue&type=script&lang=js&"
export * from "./Consignacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports